import { useEffect, useState } from 'react';
import { Props } from 'shared/@types';

export function DeferredClientRender({ children, timeout = 1500 }: Props<{ timeout?: number }>) {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    let idleId: number | undefined;
    let timeoutId: number | undefined;

    function cleanup() {
      window.removeEventListener('load', schedule);
      window.removeEventListener('pointerdown', reveal, { capture: true });
      window.removeEventListener('keydown', reveal, { capture: true });
      if (idleId !== undefined) window.cancelIdleCallback(idleId);
      if (timeoutId !== undefined) window.clearTimeout(timeoutId);
    }

    function reveal() {
      cleanup();
      setShouldRender(true);
    }

    function schedule() {
      if (typeof window.requestIdleCallback === 'function') {
        idleId = window.requestIdleCallback(reveal, { timeout });
      } else {
        timeoutId = window.setTimeout(reveal, timeout);
      }
    }

    // An idle main thread can still be downloading the LCP image. Wait for load
    // before adding background chunks, but never make an interaction wait for it.
    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
    }
    window.addEventListener('pointerdown', reveal, { once: true, capture: true, passive: true });
    window.addEventListener('keydown', reveal, { once: true, capture: true });

    return cleanup;
  }, [timeout]);

  return shouldRender ? <>{children}</> : null;
}
